const ABProcessTaskServiceAccountingJEArchiveCore = require("../../../core/process/tasks/ABProcessTaskServiceAccountingJEArchiveCore");
module.exports = class ABProcessTaskServiceAccountingJEArchive extends (
   ABProcessTaskServiceAccountingJEArchiveCore
) {};
